import { MOMENTOS } from "@/content/moments";

export function Marquee() {
  const items = MOMENTOS.map((m) => m.nombre);
  return (
    <div
      className="overflow-hidden border-y border-hairline bg-parchment-surface/50 py-5"
      data-testid="marquee-momentos"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee items-center">
        {[0, 1].map((copy) => (
          <div className="flex items-center" key={copy}>
            {items.map((label, i) => (
              <span key={`${copy}-${i}`} className="flex items-center">
                <span className="px-8 font-serif text-xl italic text-ink-text sm:text-2xl">{label}</span>
                <span className="h-1.5 w-1.5 rounded-full bg-azul" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
